import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaPixelEvent } from "../utils/metaPixel";

/**
 * Fires Meta Pixel PageView on every route change (SPA) when consent is granted.
 * Renders nothing.
 */
const MetaPixelPageView = () => {
  const location = useLocation();

  useEffect(() => {
    trackMetaPixelEvent("PageView");
  }, [location.pathname]);

  return null;
};

export default MetaPixelPageView;
